if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;

      if (!this.elements.viewer || !this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const btn = mediaToSwitch.querySelector('button');
        if (btn) btn.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });

      if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      if (!this.elements.thumbnails || !event?.detail?.currentElement) return;
      const id = event.detail.currentElement.dataset.mediaId;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${id}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant && this.filteringOption) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach((slide) => {
          const alt = slide.dataset.alt;
          if (alt === currentVariant[this.filteringOption] || alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      this.preventStickyHeader();

      requestAnimationFrame(() => {
        if (typeof activeMedia.scrollIntoView === 'function') {
          activeMedia.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        }
      });

      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        requestAnimationFrame(() => {
          if (this.elements.viewer?.initPages) this.elements.viewer.initPages();
          if (this.elements.viewer?.update) this.elements.viewer.update();
        });
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
      const btn = thumbnail.querySelector('button');
      if (btn) btn.setAttribute('aria-current', 'true');

      if (
        this.elements.thumbnails.isSlideVisible &&
        this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)
      ) return;

      requestAnimationFrame(() => {
        if (typeof thumbnail.scrollIntoView === 'function') {
          thumbnail.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });
    }

    announceLiveRegion(activeItem, position) {
      if (!this.elements.liveRegion) return;
      let image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) image = activeItem.querySelector('img');
      if (!image) return;

      const announce = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position || '');
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'true');
        }, 2000);
      };

      if (image.complete) {
        announce();
      } else {
        image.addEventListener('load', announce, { once: true });
      }
    }

    playActiveMedia(activeItem) {
      if (window.pauseAllMedia) window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (this.elements.viewer.sliderItems && this.elements.viewer.sliderItems.forEach) {
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  });
}
